export enum LengthUnit {
  CM = 0,
  M = 1,
  MM = 2
};
